export class AddressPlantGateListLoad {
  public static readonly type = '[AddressPlantGateList] Load';
}

export class AddressPlantGateListInitialState {
  public static readonly type = '[AddressPlantGateList] Set initial state';
}
